import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "general__trash",
  "use": "general__trash-usage",
  "viewBox": "0 0 11 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11 16\" id=\"general__trash\">\n  <path stroke-linecap=\"round\" stroke-width=\"1.5\" d=\"M1.5 14.5H10m0-8v8m-8.5-8v8m0-11H10M3.5 1H8\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol